export const LANGUAGES = [
    {
        id: "en",
        value: "English",
    },
    {
        id: "pt",
        value: "Portuguese",
    },
    {
        id: "fr",
        value: "Franch"
    },
    {
        id: "es",
        value: "Espanish"
    },
    {
        id: "rs",
        value: "Russian"
    }
]